import store from '@/store/index'
// import vue from '@/main'
import { TencentQRCode } from '@ibu/jslib'
import { SfCaptchaValid, removeSfCaptcha } from '@/utils/SfCaptcha'

export const qrcodeValid = (callback) => {
  removeSfCaptcha()
  const language = store.getters.language
  // 验证码国际化
  const lang = {
    'zh-CN': 'zh-cn',
    'zh-HK': 'zh-hk',
    'en': 'en',
    'ja-JP': 'ja',
    'ko-KR': 'ko',
    'th-TH': 'th',
    'vi-VN': 'vi'
  }
  return TencentQRCode.qrcodeValid(callback, lang[language])
}
export const hideTencentQRCode = TencentQRCode.destroy // 隐藏图形验维码

export const captchaMiddleHandler = ({ res, element, bid, containerId, initTxFuns, initSfFuns, demotionFuns }) => {
  console.log('腾讯验证码res', res)
  const ret = res?.ret
  const errorCode = res?.errorCode
  if (ret === 2) { // 主动关闭腾讯滑块验证码，不做任何其他处理
    return
  }
  if (ret === 0 && !errorCode) { // 验证成功,显示腾讯滑块验证码
    initTxFuns && initTxFuns(res)
  } else if (errorCode) { // 出现异常（包括TCaptcha.js加载问题），处理降级方案
    // errorCode有值，则考虑降级
    console.log('降级方案', res)
    hideTencentQRCode() // 关闭腾讯滑块验证码
    if (initSfFuns) {
      SfCaptchaValid(initSfFuns)
    } else {
      demotionFuns && demotionFuns()
      element?.onClose() // 关闭旧滑块验证码
      element?.onVerifyPass() // 开启旧滑块验证码
    }
  }
}
